import type { AbgleichZeile } from '../../../hooks/useMitarbeiterabgleich/entities/Mitarbeiterabgleich';

export function mitarbeiterName(zeile: AbgleichZeile): string {
  const daten = zeile.datev ?? zeile.e2n;
  return daten ? `${daten.vorname} ${daten.nachname}` : zeile.id;
}
